import React from 'react';
import { Phone, CheckCircle, Wrench, AlertTriangle, DollarSign } from 'lucide-react';
export function PowerStroke73LPage() {
  return <div className="min-h-screen bg-gray-50" data-id="element-7701">
      {/* Hero Section */}
      <div className="bg-gradient-to-r from-[#B1050B] to-[#8A0408] text-white py-16" data-id="element-7702">
        <div className="container mx-auto px-4" data-id="element-7703">
          <h1 className="text-4xl md:text-5xl font-bold mb-4 text-center" data-id="element-7704">
            Ford 7.3L PowerStroke Engine Repair
          </h1>
          <p className="text-xl text-gray-100 text-center" data-id="element-7705">
            Maintenance, Inspection, Diagnostics, and Repair
          </p>
        </div>
      </div>

      {/* Main Content */}
      <div className="container mx-auto px-4 py-12" data-id="element-7706">
        <div className="max-w-4xl mx-auto" data-id="element-7707">
          {/* Three Engine Models */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7708">
            <div className="grid md:grid-cols-3 gap-6 mb-8" data-id="element-7709">
              <div className="text-center" data-id="element-7710">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/7.3.jpg?opt=w3" alt="Ford 7.3 liter Powerstroke Diesel engines repaired" title="7.3 liter power stroke engine" className="w-full h-auto rounded-lg mb-4" data-id="element-7711" />
                <p className="text-lg font-bold text-gray-900" data-id="element-7712">
                  7.3 Power Stroke
                </p>
                <p className="font-semibold text-green-700 mt-2" data-id="element-7713">The "Good"</p>
              </div>

              <div className="text-center" data-id="element-7714">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/6.0l.jpg?opt=w3" alt="How to repair your powerstroke engine from Ford Motor Company" title="6.0 Powerstroke Engine" className="w-full h-auto rounded-lg mb-4" data-id="element-7715" />
                <a href="/services/powerstroke-6-0" className="text-lg font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7716">
                  6.0 Power Stroke
                </a>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7717">The "Bad"</p>
              </div>

              <div className="text-center" data-id="element-7718">
                <img src="//drwzpk38qkpfb.cloudfront.net/www.garrettauto.com/uploaded/images/imagesCAB65B34.jpg?opt=w3" alt="Common problems and repairs for Ford Powerstroke Diesel Engines" title="6.4 Liter Power Stroke Engine" className="w-full h-auto rounded-lg mb-4" data-id="element-7719" />
                <a href="/services/powerstroke-6-4" className="text-lg font-bold text-[#B1050B] hover:text-[#8A0408] transition-colors" data-id="element-7720">
                  6.4 Power Stroke
                </a>
                <p className="font-semibold text-gray-700 mt-2" data-id="element-7721">The "Ugly"</p>
              </div>
            </div>
          </div>

          {/* Service Banner */}
          <div className="bg-[#910808] text-white rounded-lg shadow-md p-8 mb-8 text-center" data-id="element-7722">
            <h2 className="text-2xl font-bold" data-id="element-7723">
              Ford 7.3L PowerStroke engine maintenance, inspection, diagnostics,
              and repair.
            </h2>
          </div>

          {/* Engine History */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7724">
            <h2 className="text-3xl font-bold text-gray-900 mb-6 text-center" data-id="element-7725">
              7.3 liter Power Stroke Engine
            </h2>

            <h3 className="text-2xl font-bold text-gray-900 mb-4" data-id="element-7726">
              7.3 Powerstroke
            </h3>

            <p className="text-gray-700 mb-4" data-id="element-7727">
              The first 7.3L was produced from 1988-1993. The original 7.3L
              diesel was a non-turbo charged indirect injection (IDI) engine,
              followed shortly after by a turbo charged version. It was very
              similar to the previous 6.9l IDI diesel engine, which was simply
              bored out for more torque. This engine is not considered in the
              powerstroke family. In 1994, the 7.3L underwent some changes. The
              7.3L was changed to a direct injection (DI) engine from the
              original IDI engine.
            </p>

            <p className="text-gray-700 mb-4" data-id="element-7728">
              Ford also added electronic fuel injectors and gave it the name
              Power Stroke. This model produced up to 250 hp (190 kW) and 525
              lb·ft (712 N·m) of torque. The new 7.3L DI Power stroke had
              "single shot" HEUI (hydraulic electronic unit injectors) fuel
              injectors and ran a 15º high pressure oil pump (HPOP) to create
              fuel injection pressures. The turbine housing was a 1.15 A/R. In
              1999, an air to air intercooler was added. The intercooler cooled
              the charged air from the turbo making it denser. The cooler,
              denser air would increase the horsepower potential of the engine,
              while also reducing exhaust gas temperatures (EGTs). The turbine
              housing was changed to a .84 A/R housing and a wastegate was
              added.
            </p>

            <p className="text-gray-700 mb-6" data-id="element-7729">
              The "single shot" HEUI injectors were upgraded to "split shot"
              injectors. With larger injectors, the HPOP was advanced to 17º to
              increase fuel pressures. The 7.3L DI Power Stroke was in
              production up until 2004 when it was replaced by the 6.0L. The 7.3
              IDI and 7.3 Powerstroke are not the same engine at all except
              manufactured by International for Ford.
            </p>

            <div className="bg-green-50 border-l-4 border-green-500 p-6" data-id="element-7730">
              <p className="text-gray-800 font-bold text-lg" data-id="element-7731">
                This is known to be the longest lasting and most reliable
                powerstroke engine.
              </p>
            </div>
          </div>

          {/* Common Issues and Repairs */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7732">
            <h2 className="text-3xl font-bold text-gray-900 mb-8 text-center" data-id="element-7733">
              Common 7.3L Issues and Repairs
            </h2>

            <div className="space-y-6" data-id="element-7734">
              {/* IPR Valve */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-7735">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-7736">
                  <Wrench className="mr-2 text-[#B1050B]" size={20} data-id="element-7737" />
                  IPR Valve
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7738">
                  The IPR VALVE is located in the valley on the HPOP. These
                  often stick, sensors go bad or the wires can corrode or get
                  cut.
                </p>
                <p className="text-gray-600 italic" data-id="element-7739">Replacement required.</p>
              </div>

              {/* IDM */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-7740">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-7741">
                  <Wrench className="mr-2 text-[#B1050B]" size={20} data-id="element-7742" />
                  IDM (Injector Driver Module)
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7743">
                  IDM located on drivers side fender can go bad and will cause a
                  no-start or rough running and cut outs in revving/rpm.
                </p>
                <p className="text-gray-600 italic" data-id="element-7744">Replacement required.</p>
              </div>

              {/* CPS Sensor */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-7745">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-7746">
                  <AlertTriangle className="mr-2 text-red-600" size={20} data-id="element-7747" />
                  Bad CPS Sensor
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7748">
                  Bad CPS sensor causes the engine to cut out and eventually
                  stop running. The engine will not start until it sits for
                  extended period or is reset by disconnecting batteries for a
                  period of time.
                </p>
                <p className="text-gray-600 italic" data-id="element-7749">
                  Requires replacement when bad. We use OEM as aftermarket CPS
                  sensors can be defective out of the box.
                </p>
              </div>

              {/* UVCH Connectors */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-7750">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-7751">
                  <AlertTriangle className="mr-2 text-red-600" size={20} data-id="element-7752" />
                  Bad UVCH Connectors
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7753">
                  These can ground out on your glow plugs, causing rough running
                  conditions, resulting in a rocking motion of the truck and
                  will often sputter and die. There are four connectors on your
                  block/heads located under the valve covers.
                </p>
                <p className="text-gray-600 italic" data-id="element-7754">
                  Physically inspect them by unplugging and check for cut wires
                  or burned connectors. If there is any damage, replacement is
                  necessary.
                </p>
              </div>

              {/* Clogged Fuel Filter */}
              <div className="border-l-4 border-green-500 pl-6" data-id="element-7755">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-7756">
                  <CheckCircle className="mr-2 text-green-600" size={20} data-id="element-7757" />
                  Clogged Fuel Filter
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7758">
                  Clogged fuel filter will often cause long cranking or slight
                  loss in power, since the injectors can't get the fuel they
                  need to keep the engine running properly.
                </p>
                <p className="text-green-700 font-semibold" data-id="element-7759">
                  Replacing fuel filter is routine maintenance and can save you
                  aggravation, time and money.
                </p>
              </div>

              {/* Lift Pump Failure */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-7760">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-7761">
                  <Wrench className="mr-2 text-[#B1050B]" size={20} data-id="element-7762" />
                  Lift Pump Failure
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7763">
                  Lift pump failure will cause a no-start situation. If the lift
                  pump is inspected and determined to be the cause of no-start,
                  replacement is necessary.
                </p>
              </div>

              {/* Engine Overheating */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-7764">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-7765">
                  <AlertTriangle className="mr-2 text-red-600" size={20} data-id="element-7766" />
                  Engine Overheating
                </h3>
                <p className="text-gray-700" data-id="element-7767">
                  Engine overheating can be caused by bad radiator, bad
                  thermostat, bad water pump, or bad coolant.
                </p>
              </div>

              {/* Bad ICP Sensor */}
              <div className="border-l-4 border-[#B1050B] pl-6" data-id="element-7768">
                <h3 className="text-xl font-bold text-gray-900 mb-2 flex items-center" data-id="element-7769">
                  <Wrench className="mr-2 text-[#B1050B]" size={20} data-id="element-7770" />
                  Bad ICP Sensor
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7771">
                  A bad ICP sensor will cause the engine to cut in and out,
                  often stops running altogether and may not restart.
                </p>
                <p className="text-gray-600 italic" data-id="element-7772">
                  Diagnosis and replacement is necessary if found to be bad.
                </p>
              </div>
            </div>
          </div>

          {/* Additional Common Issues */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7773">
            <h2 className="text-2xl font-bold text-gray-900 mb-6" data-id="element-7774">
              Additional Common Issues
            </h2>

            <div className="space-y-6" data-id="element-7775">
              {/* Climate Control Hissing */}
              <div className="bg-blue-50 rounded-lg p-6" data-id="element-7776">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7777">
                  Climate Control Hissing
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7778">
                  Hissing from the dash when on "Max A/C" or "Defrost" selection
                  is made on the Climate Control Selector. Open the hood and
                  look to the back left (as you are looking at the motor) of the
                  Engine Bay. Near the firewall and right fender there is a vent
                  blending door actuated by a white (factory) 1/8" vacuum line.
                </p>
                <p className="text-gray-700 mb-2" data-id="element-7779">
                  <strong data-id="element-7780">Fix:</strong> Inspect for dry/cracking/broken vacuum
                  line and replace. Hissing under the dash will go away.
                </p>
                <div className="flex items-center text-green-700 font-semibold" data-id="element-7781">
                  <DollarSign size={18} className="mr-1" data-id="element-7782" />
                  <span data-id="element-7783">Easy Fix - Cost: $10</span>
                </div>
              </div>

              {/* Fuel Heater */}
              <div className="bg-yellow-50 rounded-lg p-6" data-id="element-7784">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7785">
                  Fuel Heater
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7786">
                  Fuel heater shorts out and blows maxifuse #22, disabling the
                  PCM. Disconnect the fuel heater, replace fuse, re-try start.
                </p>
                <div className="flex items-center text-green-700 font-semibold" data-id="element-7787">
                  <DollarSign size={18} className="mr-1" data-id="element-7788" />
                  <span data-id="element-7789">
                    Replacement cost: $3 for the fuse (always carry spare fuses,
                    including maxifuses, in the glove box)
                  </span>
                </div>
              </div>

              {/* Glow Plugs */}
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-7790">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7791">
                  Glow Plugs
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7792">
                  Usual tests for GP relay function, UVCH continuity, resistance
                  of the glow plugs.
                </p>
                <p className="text-gray-600 italic" data-id="element-7793">
                  Replacement cost depends on what's found to be defective.
                </p>
              </div>

              {/* Block Heater */}
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-7794">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7795">
                  Block Heater
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7796">
                  Usually it's just the cord, not the heater itself. Test with
                  an ohmmeter / continuity tester.
                </p>
                <div className="flex items-center text-green-700 font-semibold" data-id="element-7797">
                  <DollarSign size={18} className="mr-1" data-id="element-7798" />
                  <span data-id="element-7799">
                    Replacement cost: $20-30 for a generic cord that fits our
                    heaters, available at NAPA
                  </span>
                </div>
              </div>

              {/* Coolant SCA Maintenance */}
              <div className="bg-red-50 rounded-lg p-6" data-id="element-7800">
                <h3 className="text-lg font-bold text-gray-900 mb-2 flex items-center" data-id="element-7801">
                  <AlertTriangle className="mr-2 text-red-600" size={20} data-id="element-7802" />
                  Coolant SCA Maintenance (CRITICAL)
                </h3>
                <p className="text-gray-700 mb-2" data-id="element-7803">
                  SCA degradation results eventually in cavitation.
                </p>
                <p className="text-red-700 font-bold mb-2" data-id="element-7804">
                  Repair cost - you don't want to know (engine replacement)
                </p>
                <div className="bg-green-100 border-l-4 border-green-500 p-4 mt-3" data-id="element-7805">
                  <p className="text-gray-800 font-semibold mb-1" data-id="element-7806">
                    Prevention:
                  </p>
                  <ul className="list-disc list-inside text-gray-700" data-id="element-7807">
                    <li data-id="element-7808">
                      $20-ish for a bottle of SCA and some test strips if
                      coolant is still fresh
                    </li>
                    <li data-id="element-7809">$100+ for complete coolant flush</li>
                  </ul>
                </div>
              </div>

              {/* Clutch Linkage/Hydraulics */}
              <div className="bg-gray-50 rounded-lg p-6" data-id="element-7810">
                <h3 className="text-lg font-bold text-gray-900 mb-2" data-id="element-7811">
                  Clutch Linkage/Hydraulics Issues
                </h3>
                <p className="text-gray-700 mb-3" data-id="element-7812">
                  Weak hydraulics, or worn pedal box bushings, or worn lever arm
                  / eyelet bushing. Extreme eyelet bushing wear can lead to the
                  eyelet expanding (ovalizing).
                </p>
                <div className="space-y-1 text-gray-700" data-id="element-7813">
                  <p data-id="element-7814">
                    <strong data-id="element-7815">Repair/Replacement costs:</strong>
                  </p>
                  <ul className="list-disc list-inside ml-4" data-id="element-7816">
                    <li data-id="element-7817">
                      $120-150 for the hydraulics (complete pre-bled system)
                    </li>
                    <li data-id="element-7818">$20 for the pedal box bushings (dealer)</li>
                    <li data-id="element-7819">
                      $5 for the "cheap" arm/eyelet bushing repair (brass tubing
                      + drill stop collar)
                    </li>
                    <li data-id="element-7820">$20 for the "fancy" arm/eyelet bushing repair</li>
                  </ul>
                </div>
              </div>
            </div>
          </div>

          {/* Why 7.3L is "The Good" */}
          <div className="bg-white rounded-lg shadow-md p-8 mb-8" data-id="element-7821">
            <h2 className="text-2xl font-bold text-gray-900 mb-6 text-center" data-id="element-7822">
              Why the 7.3L is "The Good"
            </h2>

            <div className="grid md:grid-cols-2 gap-6" data-id="element-7823">
              <div className="bg-green-50 rounded-lg p-6" data-id="element-7824">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7825">
                  Strengths:
                </h3>
                <ul className="space-y-2 text-gray-700" data-id="element-7826">
                  <li className="flex items-start" data-id="element-7827">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7828" />
                    <span data-id="element-7829">Longest lasting Powerstroke engine</span>
                  </li>
                  <li className="flex items-start" data-id="element-7830">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7831" />
                    <span data-id="element-7832">Most reliable Powerstroke design</span>
                  </li>
                  <li className="flex items-start" data-id="element-7833">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7834" />
                    <span data-id="element-7835">Simple, proven technology</span>
                  </li>
                  <li className="flex items-start" data-id="element-7836">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7837" />
                    <span data-id="element-7838">Easier to diagnose and repair</span>
                  </li>
                  <li className="flex items-start" data-id="element-7839">
                    <CheckCircle className="text-green-600 mr-2 flex-shrink-0 mt-1" size={18} data-id="element-7840" />
                    <span data-id="element-7841">Lower repair costs overall</span>
                  </li>
                </ul>
              </div>

              <div className="bg-blue-50 rounded-lg p-6" data-id="element-7842">
                <h3 className="text-xl font-bold text-gray-900 mb-4" data-id="element-7843">
                  Common Maintenance:
                </h3>
                <ul className="space-y-2 text-gray-700" data-id="element-7844">
                  <li className="flex items-start" data-id="element-7845">
                    <span className="text-blue-600 mr-2 flex-shrink-0 mt-1" data-id="element-7846">
                      •
                    </span>
                    <span data-id="element-7847">Regular fuel filter changes</span>
                  </li>
                  <li className="flex items-start" data-id="element-7848">
                    <span className="text-blue-600 mr-2 flex-shrink-0 mt-1" data-id="element-7849">
                      •
                    </span>
                    <span data-id="element-7850">Coolant SCA testing and maintenance</span>
                  </li>
                  <li className="flex items-start" data-id="element-7851">
                    <span className="text-blue-600 mr-2 flex-shrink-0 mt-1" data-id="element-7852">
                      •
                    </span>
                    <span data-id="element-7853">Sensor inspections (CPS, ICP, IPR)</span>
                  </li>
                  <li className="flex items-start" data-id="element-7854">
                    <span className="text-blue-600 mr-2 flex-shrink-0 mt-1" data-id="element-7855">
                      •
                    </span>
                    <span data-id="element-7856">UVCH connector checks</span>
                  </li>
                  <li className="flex items-start" data-id="element-7857">
                    <span className="text-blue-600 mr-2 flex-shrink-0 mt-1" data-id="element-7858">
                      •
                    </span>
                    <span data-id="element-7859">Glow plug system maintenance</span>
                  </li>
                </ul>
              </div>
            </div>
          </div>

          {/* CTA Section */}
          <div className="bg-gradient-to-r from-gray-900 to-gray-800 text-white rounded-lg shadow-xl p-8 text-center" data-id="element-7860">
            <h2 className="text-3xl font-bold mb-4" data-id="element-7861">
              Expert 7.3L Powerstroke Service
            </h2>
            <p className="text-xl mb-6" data-id="element-7862">
              Keep your reliable 7.3L running strong with professional
              maintenance and repair
            </p>
            <a href="tel:2484788382" className="inline-flex items-center bg-[#B1050B] hover:bg-[#8A0408] text-white px-8 py-4 rounded-lg font-bold text-lg transition-colors shadow-lg" data-id="element-7863">
              <Phone className="mr-3" size={24} data-id="element-7864" />
              Call (248) 478-8382
            </a>
            <p className="mt-4 text-gray-300" data-id="element-7865">
              24175 Industrial Park Dr., Farmington Hills, MI 48335
            </p>
          </div>
        </div>
      </div>
    </div>;
}